import Badge from './Badge';

export default {
  id: 'radial_14',
  title: 'Radial_14',
  colors: 2,
  premium: true,
  BadgeComponentStateless: Badge
};
